import isPropValid from "@emotion/is-prop-valid";
import { size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import boxMixin from "../../../mixins/box";
import { ellipsis } from "../../../mixins/ellipsis";
import { textColorMixin } from "../../../mixins/textColor";
export const TextHolder = styled.span.withConfig({
    shouldForwardProp: isPropValid,
}) `
  display: block;
  font-size: ${size.font.text};
  line-height: ${size.lineHeight.text.default};
  white-space: pre-line;
  && {
    ${textColorMixin};
  }

  ${boxMixin};

  &.ellipsis {
    ${ellipsis};
  }

  &.squished {
    line-height: ${size.lineHeight.text.squished};
  }

  &.crossOut {
    text-decoration: line-through;
  }

  &.small,
  & small {
    font-size: ${size.font.smallText};
    line-height: ${size.lineHeight.smallText.default};
  }

  &.squished small,
  &.squished.small {
    line-height: ${size.lineHeight.smallText.squished};
  }

  &.noWrap {
    white-space: nowrap;
    flex-shrink: 0;
  }

  &.breakWord {
    word-break: break-word;
  }

  &.inline {
    display: inline-flex;
  }

  &.center {
    text-align: center;
    align-self: auto;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEhvbGRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RleHQvc3R5bGVkL1RleHRIb2xkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxXQUFXLE1BQU0sd0JBQXdCLENBQUM7QUFDakQsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3RFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sUUFBUSxNQUFNLHFCQUFxQixDQUFDO0FBQzNDLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSwwQkFBMEIsQ0FBQztBQUNwRCxPQUFPLEVBQUUsY0FBYyxFQUF1QixNQUFNLDJCQUEyQixDQUFDO0FBRWhGLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUMvQyxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBcUI7O2VBRVIsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJO2lCQUNaLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLE9BQU87OztNQUd2QyxjQUFjOzs7SUFHaEIsUUFBUTs7O01BR04sUUFBUTs7OzttQkFJSyxJQUFJLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxRQUFROzs7Ozs7Ozs7aUJBUy9CLElBQUksQ0FBQyxJQUFJLENBQUMsU0FBUzttQkFDakIsSUFBSSxDQUFDLFVBQVUsQ0FBQyxTQUFTLENBQUMsT0FBTzs7Ozs7bUJBS2pDLElBQUksQ0FBQyxVQUFVLENBQUMsU0FBUyxDQUFDLFFBQVE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBb0JwRCxDQUFDIn0=